<template>
  <div class="control-wrapper">
    <button @click="toggleMenu" class="toggle-button">
      {{ isMenuVisible ? '隱藏' : '顯示' }}
    </button>
    
    <section class="control-container" :class="{ 'menu-visible': isMenuVisible }">
      <h3 class="control-header">發票管理</h3>
      
      <section class="item-container">
        <section
          class="control-item"
          v-for="(control, key) in controls"
          :key="key"
        >
          <section class="control">
            <span class="item-label">
              {{ control.label }}
            </span>
            <div class="flex-1" v-if="control.inputType === 'date'">
              <flat-pickr
                v-model="controlValue[control.vModel]"
                class="form-control"
                :config="{ dateFormat: 'Y-m-d' }"
              />
            </div>
            <div class="flex-1" v-else>
              <input
                :class="
                  control.inputType === 'checkbox'
                    ? 'input-checkbox'
                    : 'input-box'
                "
                :type="control.inputType"
                :value="controlValue[control.vModel]"
                :checked="controlValue[control.vModel]"
                @input="setInput($event, control.vModel, control.inputType)"
                @change="setInput($event, control.vModel, control.inputType)"
              />
            </div>
          </section>

          <section class="options-container">
            <section class="options-item">
              <span class="options-title"> Type: </span>

              <span class="options-value">
                {{ control.type }}
              </span>
            </section>

            <section class="options-item">
              <span class="options-title"> Options: </span>

              <span class="options-value">
                {{ control.options }}
              </span>
            </section>
          </section>

          <section v-if="control.label === 'manual-pagination:'">
            <b>Note:</b> <br />
            When enabling this prop, the prop <br />
            <b> paginate-elements-by-height </b> will not be used. Instead the
            pagination process will rely on the elements with a class
            "html2pdf__page-break" to know where to page break.
          </section>
        </section>
      </section>

      <b-button
        :disabled="isGenerating"
        class="generate-btn"
        style="margin-bottom: 10px"
        :to="{ name: 'invoices-list' }"
        v-if="ability.can('read', 'invoices')"
      >
        發票列表
      </b-button>
      <b-button
        :disabled="isGenerating"
        class="generate-btn"
        style="margin-bottom: 10px"
        :to="{ name: 'invoice-edit', params: { id: invoiceData.id } }"
        v-if="ability.can('update', 'invoices')"
      >
        修改發票
      </b-button>

      <button
        :disabled="isGenerating"
        class="generate-btn"
        style="margin-bottom: 10px"
        @click="$emit('generateReport')"
      >
        {{ isGenerating ? "Loading..." : "列印發票" }}
      </button>

      <section class="progress-container">
        <div class="progress-bar">
          <div class="progress" :style="`width: ${progress}%;`" />
        </div>

        <section class="generating-label" v-if="progress !== 0">
          <span class="label-title">
            {{ progress === 100 ? "列印發票完成" : "列印發票中" }}
          </span>

          <span class="label-progress">
            {{ `${progress} %` }}
          </span>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import { BButton } from "bootstrap-vue";
import ability from "@/libs/acl/ability";
import { sanitizeFilename } from "@core/utils/filter";

export default {
  components: {
    BButton,
    flatPickr,
  },
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    invoiceData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ability,
      controls: [
        {
          label: "檔案名稱:",
          type: "String",
          options: "Any String",
          inputType: "text",
          vModel: "filename",
        },

        {
          label: "簽署日期:",
          type: "Date",
          options: "Any Date",
          inputType: "date",
          vModel: "sign_date",
        },

        // {
        //   label: "顯示 HK$0:",
        //   type: "Boolean",
        //   options: "true, false",
        //   inputType: "checkbox",
        //   vModel: "showZero",
        // },
      ],
      isMenuVisible: true
    };
  },
  mounted() {
    const rawFilename = this.invoiceData.invoice_number +
      "(" +
      this.invoiceData.project_name +
      ")";
    this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';

    this.controlValue.sign_date = this.getDateTime(null, true);
    console.log(this.controlValue.sign_date);
  },

  computed: {
    ...mapFields(["controlValue"]),

    isGenerating() {
      return this.progress !== 0 && this.progress !== 100;
    },
    fileName() {
      return this.invoiceData.invoice_number;
    },
  },
  watch: {
    fileName() {
      const rawFilename = this.invoiceData.invoice_number +
        "(" +
        this.invoiceData.project_name +
        ")";
      this.controlValue.filename = sanitizeFilename(rawFilename) + '.pdf';
    },
  },

  methods: {
    setInput(e, key, inputType) {
      let value = e.target.value;

      if (inputType === "checkbox") {
        value = e.target.checked;
      }

      if (inputType === "number") {
        value = e.target.value ? parseFloat(e.target.value) : 0;
      }

      this.$set(this.controlValue, key, value);
    },

    checkVaild() {
      if (this.newInvoiceData.cost_items.length <= 0) {
        this.makeToast("danger", "Warning", "請輸入最少一個成本記錄。");
        return false;
      } else {
        return true;
      }
    },
    onSubmit() {
      if (!this.checkVaild()) {
        return;
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;

          store
            .dispatch("invoice/editInvoice", this.newInvoiceData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";


</style>